var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "channel-header" }, [
    _c("div", { staticClass: "channel-info" }, [
      _c("div", {
        staticClass: "channel-avatar",
        style: { backgroundImage: "url(" + _vm.category.iconUrl + ")" }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "channel-meta" }, [
        _c("div", { staticClass: "channel-name" }, [
          _vm._v(_vm._s(_vm.category.name))
        ])
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "action-buttons" },
      [
        _c("like-button", {
          attrs: { customClass: "action-btn", item: _vm.video },
          on: {
            handleClickLike: function($event) {
              _vm.$emit("handleLikeVideo")
            }
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-271d94f8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-271d94f8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/video/components/VideoHeader.vue
// module id = null
// module chunks = 